window.appInterFace = (val, data) => {
  alert(val);
};
export function qr_camera_call() {
  let param = {
    action: 'qrcamera',
    callback: 'appInterFace', //읽혀진 코드값 전달받을 javascript함수명(웹소스에 정의필요)
  };
  window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(param));
}

export function get_code(val) {
  alert(`val: ${val}`); //읽혀진 값 확인(해당값을 사용하는 로직에 적용하면됩니다.)
  return val;
}
